var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyPhotoZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 14.937h126.25v25.125h-126.25z",
    fill: "#fbc56d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.125 40.062h109.75a0 0 0 0 1 0 0v68a5 5 0 0 1 -5 5h-99.75a5 5 0 0 1 -5-5v-68a0 0 0 0 1 0 0z",
    fill: "#ebae56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.765 62.816h-27.53a6.377 6.377 0 0 1 -6.376-6.377 6.376 6.376 0 0 1 6.376-6.376h27.53a6.376 6.376 0 0 1 6.376 6.376 6.377 6.377 0 0 1 -6.376 6.377z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.75 80.941h54.5v22.122h-54.5z",
    fill: "#2c3b73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.875 93.752h-35.75a1.75 1.75 0 0 1 0-3.5h35.75a1.75 1.75 0 0 1 0 3.5z",
    fill: "#7fe881"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyPhotoZip);
export default __webpack_public_path__ + "static/media/property-photo-zip.a650d1d9c4dd25736f8dd36b4bc4e3dd.svg";
export { ForwardRef as ReactComponent };